import { useEffect, useState } from "react";
import { MapPin, Loader2 } from "lucide-react";
import { reverseGeocode } from "@/lib/reverseGeocode";

interface Props {
  lat: number | null | undefined;
  lng: number | null | undefined;
  className?: string;
  showIcon?: boolean;
}

export function AddressFromCoords({ lat, lng, className, showIcon = true }: Props) {
  const [addr, setAddr] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (lat == null || lng == null) return;
    let cancelled = false;
    setLoading(true);
    reverseGeocode(Number(lat), Number(lng))
      .then((a) => !cancelled && setAddr(a))
      .finally(() => !cancelled && setLoading(false));
    return () => {
      cancelled = true;
    };
  }, [lat, lng]);

  if (lat == null || lng == null) return null;

  const mapsHref = `https://www.google.com/maps?q=${lat},${lng}`;

  return (
    <a
      href={mapsHref}
      target="_blank"
      rel="noopener noreferrer"
      className={`inline-flex items-center gap-1 hover:underline ${className || ""}`}
      title="Open in Google Maps"
    >
      {showIcon && <MapPin className="h-3.5 w-3.5 shrink-0" />}
      {loading && !addr ? (
        <span className="inline-flex items-center gap-1 text-muted-foreground">
          <Loader2 className="h-3 w-3 animate-spin" /> resolving…
        </span>
      ) : (
        <span className="truncate">{addr || `${Number(lat).toFixed(5)}, ${Number(lng).toFixed(5)}`}</span>
      )}
    </a>
  );
}
